<template>
    <div id="nav" class="list-group list-group-flush">
        <div class="d-none d-lg-block">
            <router-link class="list-group-item" to="/">Einladung</router-link>
            <router-link class="list-group-item" to="/ablauf">Ablauf</router-link>
            <router-link class="list-group-item" to="/infos">Infos</router-link>
            <router-link class="list-group-item" to="/bilder">Bilder</router-link>
        </div>
        <div class="d-lg-none">
            <a class="list-group-item" @click="scrollTo($event, 'top')" href="#top">Start</a>
            <a class="list-group-item" @click="scrollTo($event, 'ablauf')" href="#ablauf">Ablauf</a>
            <a class="list-group-item" @click="scrollTo($event, 'kirche')" href="#kirche">Kirche</a>
            <a class="list-group-item" @click="scrollTo($event, 'restaurant')" href="#restaurant">Restaurant</a>
            <router-link class="list-group-item" to="/bilder">Bilder</router-link>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        scrollTo(event, target) {
            const _ = this

            if (this.$router.currentRoute.name === 'home') {
                const targetNode = document.getElementById(target)
                if (targetNode && targetNode.scrollIntoView) {
                    event.preventDefault()

                    targetNode.scrollIntoView({ 'behavior': 'smooth' })

                    if (history && history.pushState) {
                        history.pushState(null, 'Hochzeit', `#${target == 'top' ? '' : target}`)
                    }
                }

                _.$emit('navigated')
            } else {
                this.$router
                    .push({ path: '/' })
                    .then(() => {
                        setTimeout(() => {
                            const targetNode = document.getElementById(target)
                            if (targetNode && targetNode.scrollIntoView) {
                                event.preventDefault()

                                targetNode.scrollIntoView({ 'behavior': 'smooth' })

                                if (history && history.pushState) {
                                    history.pushState(null, 'Hochzeit', `#${target == 'top' ? '' : target}`)
                                }
                            }

                            _.$emit('navigated')
                        }, 1000)
                    })
            }

            
        }
    }
}
</script>

<style lang="scss">
@import '~bootstrap';

#nav {
    padding: 0;

    & .list-group-item {
        background-color: rgba(255, 255, 255, 0.1);
        color: cadetblue;

        &:hover {
            background-color: rgba(255, 255, 255, 0.2);
            color: cadetblue;
            text-decoration: none;
        }
    }

    a {
        color: #2c3e50;

        &.router-link-exact-active {
            color: #42b983;
        }
    }
}

@include media-breakpoint-down(md) {
    #nav {
        & .list-group-item {
            background-color: rgba(0, 0, 0, 0.08);
            color: #2b2b2b;

            &:hover {
                background-color: rgba(0, 0, 0, 0.2);
                color: #212121;
            }
        }

        a {
            &.router-link-exact-active {
                color: #202020;
            }
        }
    }
}
</style>
